import React, { useEffect, useRef } from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import widgetRender from './bei-light';

function linechartRendering(data, action){

  //json parametres de la viz
  var widgetProperties_chart1 = {
    'generalProperties' : {
      'chartType' : 'linechart',	// barchart, pie, linechart
      'orientation' : 'horizontal',	// horizontal, vertical (for XY axis chart)
      'direction' : 'standard', 	// standard, opposite
      'margin' : {'top' : 100, 'right' : 50, 'bottom' : 50, 'left' : 50},
      'size' : {'width' : '100%', 'height' : '100%'},
      'minSize': {'width' : 420, 'height' : 330},
      'minPlotSize' : {'width' : 100, 'height' : 100},
      'activeClipPath' : false,
      'errorMsg' : 'lorem ipsum'
    },
    'detailProperties' : {
      'dataAggregation' : true,
      'dimensionFields' : ['date',''],
      'dimensionFieldsDatatype' : ['date'],
      'dimensionFieldsLabel' : ['Date'],
      'dimensionFieldsFormat' : ['%d/%m/%y'],
      'dimensionFieldsCustomSort' : [null],
      'dimensionFieldsSortOrder' : [null],
      'multiDimensionStyle' : 'grouped',		//grouped, stacked, diverging, bullet (for bullet & diverging multiDimensionStyle , 2nd axis must have 2 values max !!!)
      'calculationFields' : ['feedbackReceived','feedbackPending'],
      'calculationFieldsFormula' : ['__cumSum__', '__cumSum__'],
      'calculationFieldsLabel' : ['feedback received', 'feedback pending'],
      'calculationFieldsDatatype' : ['number', 'number'],
      'calculationFieldsFormat' : ['.2', '.2'],
      'calculationFieldsAdjustPct' : false,
      'multiCalculationFields' : {
        'active' : true,
        'mode' : 'switch',
        'action' : 'render',
        'hPosition' : 'right',
        'vPosition' : 'top',
        'vPadding' : 20,
        'btnWidth' : '100px',
        'btnFontFamily' : 'Montserrat',
        'btnFontSize' : '12px',
        'btnFontWeight' : '100',
        'btnFontStyle' : 'normal',
        'backgroundColor' : 'transparent',
        'labelColor' : '#485465',
        'selectedBackgroundColor' : '#485465',
        'selectedLabelColor' : 'white'
      },
      'calculationFieldsTotal' : ['__last__'],
      'styles' : {
        'themeScheme' : null,
         'colors' : {
          'defaultColor' : '#002380',
          'defaultStrokeColor' : '#002380',
          'defaultFillColor' : '#002380',
          'dimensionField' : ['serieIndex'],
          'dimensionFieldSortOrder' : null,
          'dimensionFieldCustomOrder' : null,
          'dimensionScaleMode' : ['categorical'],		// categorical, continous
          'scaleType' : ['scaleOrdinal'],		//scaleLinear, scaleSequential, scaleTreshold, scaleOrdinal
          'interpolator' : null,
          'scheme' : ['#002380'],
          'schemeType' : 'colorArray', // colorArray, colorGradientArray
        },
        'textures' : {
          'active' : false,
          'defaultTexture' : ''
        },
      },			
      'XYChart' : {
        'includeOrigin' : true,		//used for barchart / linechart
        'linearGridline' : false,
        'categoricalGridline' : true,
        'categoricalGridlineCentering' : false,
        'linearAxis' : false,
        'linearAxisLabel' : false,
        'linearAxisMinMaxExtendFactor' : [1, 1.1],
        'categoricalAxis' : true,
        'categoricalAxisLabel' : true,
        'categoricalAxisLabelFormat' : '%b %e',
        'categoricalAxisTick' : false,
        'categoricalAxisLabelVPadding' : 10,
        'categoricalAxisLabelTextWrapWidth' : 90,
        'categoricalAxisLabelTextWrapLineHeight' : 1.2,	
        'categoricalAxisLabelTextAnchor' : 'middle',
        'lineInterpolation' : 'curveLinear',
        'lineWidth' : 4,
        'linechartArea' : true,
        'areaDefaultColor' : '#002380',
        'areaDefaultOpacity' : 0.05,
      },
      'total' : {
        'visible' : true,
        'hPosition' : 'left',
        'vPosition' : 'top',
        'fontFamily' : 'Montserrat',
        'fontSize' : '80px',
        'fontWeight' : 200,
        'textAnchor' : 'start',
        'hPadding' : 50,
        'vPadding' : 150,
        'prefix' : '',
        'suffix' : '',
        'color' : '#626262',
        'SVG' : "<text><tspan dy='0em'>[__last__]</tspan></text>"
      },
      'axis' : {
        'fontFamily' : 'Montserrat',
        'fontSize' : '12px',
        'fontWeight' : '400',
        'color' : '#979797',
        'altColor' : '#000000',
        'labelColor' : '#65676a',
        'tickSize' : 0,
        'padding' : 0
      },		
      'gridline' : {
        'padding' : 0,
        'showExtend' : true,
        'dashArray' : '10 10',
        'width' : 0.5,
        'color' : '#979797',
        'altColor' : '#000000',
        'opacity' : 0.8
      },
      'marker' : {
        'visible' : true,
        'style' : 'square',
        'r' : 10,
        'strokeColor' : "#002380",
        'strokeWidth' : 4,
        'fillColor' : "#FFFFFF",
        'opacity' : 1
      },
      'title' : {
        'visible' : false,
        'text' : null,
        'hPosition' : 'left',
        'vPosition' : 'top',
        'hPadding' : 20,
        'vPadding' : 10,
        'alignment' : 'center',
        'fontFamily' : 'Montserrat',
        'color' : '#535353',
        'fontSize' : '18px',
        'fontWeight' : '300',
        'textAnchor' : 'middle',
        'SVG' : "<text style='text-anchor:start'><tspan dy='0.7em'>PROGRESSION</tspan></text>"
      },		
      'tooltip' : {
        'active' : true,
        'hPosition' : 'shape',	// shape, mouse, fixe
        'vPosition' : 'shape',
        'hRelPosition' : 'center',
        'vRelPosition' : 'up',
        // 'column' : ['cout','etp_contractuel','etp_ecart'],
        // 'columnSuffix' : [' ETP absence',' ETP contractuel',' ETP par rapport au indirect'],
        'lineSeparator' : true,
        'fontFamily' : 'Montserrat',
        'vPadding' : -10,
        'color' : '#535353',	//'#FFFFFF'
        'fontSize' : '15px',
        'fontWeight' : '400',
        'textAnchor' : 'start',
        'backgroundColor' : '#ffffff',	//'#535353',
        'SVG' : "<g><g><line x1='14' x2='14' y1='34' y2='80' style='stroke : #002380;stroke-width: 2' /></g><text x='10' y='14' dy='0.7em'><tspan style='font-weight:600;font-size : 18px'>[date]</tspan><tspan x='25' y='50'>Feedback received : [feedbackReceived]</tspan><tspan x='25' y='72'>Feedback pending : [feedbackPending]</tspan></text></g>",
        'variableFormat' : {'date' : {'datatype' : 'date', 'formatIn' : '%d/%m/%y', 'formatOut' : '%B %e'},
                   'feedbackReceived' : {'datatype' : 'number', 'formatOut' : '.2'},
                   'feedbackPending' : {'datatype' : 'number', 'formatOut' : '.2'}
                   },
        'tooltipSpecificFn' : null
      },
      'animation' : {
        'active' : true,
        'duration' : 600,
        'delay' : 0,
        'incrementalDelay' : 0,
        'ease' : 'easeCubic'	//default : easeCubic, easeLinear, easeBounce, easeElastic, easeExp, easeCircle
      },
      'events' : {
        'mouseover' : true,
        'click' : false
      }
    },
    'contextualProperties' :  {
      'tagId' : 'ChartProgression',					
      'dataIn' : data
    }
  }	
  
    widgetRender(widgetProperties_chart1, action);
    
  }
  
  const ChartProgression = ({ data, loading, error }) => {
  
    const d3svg = useRef(false);
  
  /*   useEffect(() => {
    }, [loading]); */
  

  useEffect(() => {
    if (d3svg.current && data) {
      const cnt = data.length;
      if (cnt !== 0) {
        linechartRendering(data, 'init');
      }
    } else d3svg.current = true;
  }, [data]);

  return (
    <>
      <div
        ref={d3svg}
        className="bar-chart-container"
        id="ChartProgression"
        role="img"
        style={{ position: 'relative', width: '500px', height: '400px' }}>
        {loading && (
          <h6 style={{ color: '#002380' }}>
            <LinearProgress />
          </h6>
        )}
        {error && <h4 style={{ color: 'red', fontSize: 14 }}>{error}</h4>}
      </div>
    </>
  );
};

export default ChartProgression;

// style={{ pointerEvents: 'all', width: '100%', height: '100%' }}
